import { addDays, subDays } from 'date-fns';

const getDateFromDaysOffsets = (currentDate: Date, dayOffsets = 0): Date => {
  if (dayOffsets > 0) {
    return addDays(currentDate, dayOffsets);
  }
  if (dayOffsets < 0) {
    return subDays(currentDate, dayOffsets * -1);
  }
  return currentDate;
};

export default getDateFromDaysOffsets;
